<template>
  <div>
    <section class="section-idw-bg">
      <div class="container">
        <div class="row">
          <div class="col-sm-12 col-lg-8 section-idw-bg-content">
            <img
              src="../assets/images/Logo_indywidualni_color.svg"
              class="internal-image idw-logo mb-4"
            />
            <h1 class="idw-h1 font-weight-bold">Określamy mocne strony</h1>
            <h1 class="idw-h1 font-weight-bold">
              i predyspozycje Twojego dziecka
            </h1>

            <a
              href="https://portal.librus.pl/rodzina/sklep/indywidualni"
              target="_blank"
              class="btn btn-default btn-cta mt-5"
              >KUP TERAZ</a
            >
          </div>
        </div>
      </div>
    </section>
    <section class="section-white">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center">
            <h2 class="kl-h2 font-weight-bold">Wspieramy uczniów i rodziców</h2>
          </div>
        </div>
        <div class="row mt-md-4">
          <div
            class="col-sm-12 col-md-6 d-flex flex-column justify-content-center"
          >
            <p class="p-0 font-paragraph">
              Portal indywidualni.pl za pomoca testów on-line rozpoznaje:
            </p>
            <ul>
              <li class="ml-3 font-paragraph--small">
                zdolności i talenty dziecka,
              </li>
              <li class="ml-3 font-paragraph--small">
                jego dominujące zmysły,
              </li>
              <li class="ml-3 font-paragraph--small">
                czy woli uczyć się indywidualnie, czy w grupie,
              </li>
              <li class="ml-3 font-paragraph--small">
                jaką ma odporność na stres,
              </li>
              <li class="ml-3 font-paragraph--small">
                czy przetrwarza informacje w sposób bardziej analityczny czy
                obrazowy.
              </li>
            </ul>
          </div>
          <div class="col-sm-12 col-md-6">
            <img
              src="../assets/images/foto/IDW_laptop.png"
              class="internal-image"
            />
          </div>
        </div>
      </div>
    </section>
    <section class="section-blue children-img-bg">
      <div class="container">
        <div class="row mb-5">
          <div class="col-12 text-center text-white">
            <h2 class="text-white">Pokazujemy sposoby na skuteczną naukę</h2>
            <h4 class="text-white mt-4">
              Uczymy metod przyspieszonego uczenia się tak, by bazując na swoich
              mocnych stronach dziecko zapamiętywało szybciej i na dłużej.
            </h4>
          </div>
        </div>
        <div class="row mt-5">
          <div class="col-lg-4 col-sm-12 text-center">
            <img
              src="../assets/images/icons/Mnozenie.png"
              class="internal-image"
            />
            <h6 class="mt-3 text-white font-paragraph">Mnożenie po japońsku</h6>
          </div>
          <div class="col-lg-4 col-sm-12 text-center">
            <img
              src="../assets/images/icons/Mnemotechniki.png"
              class="internal-image"
            />
            <h6 class="mt-3 text-white font-paragraph">Mnemotechniki</h6>
          </div>
          <div class="col-lg-4 col-sm-12 text-center">
            <img src="../assets/images/icons/Mapa.png" class="internal-image" />
            <h6 class="mt-3 text-white font-paragraph">Mapy myśli</h6>
          </div>
        </div>
      </div>
    </section>
    <section class="section-white pb-5">
      <div class="container">
        <div class="row mb-5">
          <div class="col-12 text-center text-white">
            <h2 class="kl-h2 font-weight-bold">
              Odkryj potencjał swojego dziecka
            </h2>
          </div>
        </div>
        <div class="row mb-5">
          <div class="col-sm-12 col-md-6 text-center">
            <img
              src="../assets/images/icons/IDW_pakiet-testow.png"
              class="internal-image"
            />
            <h4 class="am-h4 font-weight-bold mt-4 mb-4" style="color: #4a4a4a">
              Pakiet testów
            </h4>
            <p class="font-paragraph">
              4 testy "Mocne strony i predyspozycje" - wyniki przedstawione w
              postaci czytelnego raportu
            </p>
          </div>
          <div class="col-sm-12 col-md-6 text-center">
            <img
              src="../assets/images/icons/IDW_wygodny-dostep.png"
              class="internal-image"
            />
            <h4 class="am-h4 font-weight-bold mt-4 mb-4" style="color: #4a4a4a">
              Wygodny dostęp do informacji
            </h4>
            <p class="font-paragraph">
              Kilkadziesiąt metod i technik skutecznego uczenia się oraz karty
              pracy
            </p>
          </div>
        </div>
      </div>
    </section>
    <section class="section-grey">
      <div class="container mb-5">
        <div class="row">
          <div class="col-12 text-center mb-3">
            <h2 class="kl-h2 font-weight-bold">Galeria</h2>
          </div>
        </div>

        <image-gallery :images="gallery.images" :config="gallery.config" />
      </div>
    </section>
    <section class="section-blue discover-child">
      <div class="container">
        <div class="row mb-5 d-flex flex-row position-relative">
          <div class="col-lg-10 text-center text-white">
            <h2 class="text-white font-weight-bold my-4">
              Odkryj potencjał dziecka
            </h2>
            <a
              href="https://portal.librus.pl/rodzina/sklep/indywidualni"
              target="_blank"
              class="mt-5 btn btn-default btn-cta"
              >KUP TERAZ</a
            >
          </div>
          <img
            src="../assets/images/foto/odkryj-potencjal-dziecka.png"
            class="position-absolute discover-child__img"
          />
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import ImageGallery from "./../components/Gallery";

// Import img
import Gallery1Small from "../assets/images/gallery/LP_idw_galeria1.jpg";
import Gallery1Big from "../assets/images/gallery/idw_1.jpg";
import Gallery2Small from "../assets/images/gallery/LP_idw_galeria2.jpg";
import Gallery2Big from "../assets/images/gallery/idw_2.jpg";
import Gallery3Small from "../assets/images/gallery/LP_idw_galeria3.jpg";
import Gallery3Big from "../assets/images/gallery/idw_3.jpg";
import Gallery4Small from "../assets/images/gallery/LP_idw_galeria4.jpg";
import Gallery4Big from "../assets/images/gallery/idw_4.jpg";
import Gallery5Small from "../assets/images/gallery/LP_idw_galeria5.jpg";
import Gallery5Big from "../assets/images/gallery/idw_5.jpg";
import Gallery6Small from "../assets/images/gallery/LP_idw_galeria6.jpg";
import Gallery6Big from "../assets/images/gallery/idw_6.jpg";

export default {
  name: "IndywidualniView",
  components: {
    ImageGallery,
  },
  data() {
    return {
      gallery: {
        images: [
          {
            small_image_src: Gallery1Small,
            big_image_src: Gallery1Big,
          },
          {
            small_image_src: Gallery2Small,
            big_image_src: Gallery2Big,
          },
          {
            small_image_src: Gallery3Small,
            big_image_src: Gallery3Big,
          },
          {
            small_image_src: Gallery4Small,
            big_image_src: Gallery4Big,
          },
          {
            small_image_src: Gallery5Small,
            big_image_src: Gallery5Big,
          },
          {
            small_image_src: Gallery6Small,
            big_image_src: Gallery6Big,
          },
        ],
        config: {
          columns: 3,
        },
      },
    };
  },
  created() {
    this.$emit("showFaqHeader", false);
  },
  mounted() {
    document.title = "Indywidualni";
  },
};
</script>
